import IlluminationIcon from './component'

export default IlluminationIcon
